// FLAGS: none
// Derives the API origin from the page's own host, so one build serves every environment. A multi-label host has
// its first label swapped for REACT_APP_API_SUBDOMAIN; a single-label host such as `localhost` is returned as-is,
// which is what makes the dev server's /api proxy the path in local runs.
import { env } from "@src/env";
import { apiPaths } from "@src/constants";

export function getApiBaseUrl() {
  let hostUrl = window.location.host;
  const urlParts = new URL(`https://${hostUrl}`).hostname.split(".");

  if (urlParts.length > 1) {
    hostUrl = urlParts.slice(1).join(".");
    return `https://${env.REACT_APP_API_SUBDOMAIN}.${hostUrl}/`;
  }
  return `https://${hostUrl}/`;
}

export function getExternalLoginUrl() {
  return `${getApiBaseUrl()}${apiPaths.providerChallenge}`;
}
